/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const searchPredicatePathTypeUuidsMax = 8;

export const SearchPredicate = zod.object({
  op: zod
    .enum(['exists', 'eq', 'contains', 'gte', 'lte'])
    .describe('Comparison operator; \"exists\" matches on node presence alone'),
  pathTypeUuids: zod
    .array(zod.uuid())
    .min(1)
    .max(searchPredicatePathTypeUuidsMax)
    .describe('Content-type UUID path (CONTAINS descent); last entry is the matched node type'),
  value: zod.string().optional().describe('Comparison value as text (omit for \"exists\")'),
  valueType: zod
    .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
    .optional()
    .describe('How to interpret value (default STRING)'),
});

export type SearchPredicate = zod.input<typeof SearchPredicate>;
export type SearchPredicateOutput = zod.output<typeof SearchPredicate>;
